var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, } from "vue-property-decorator";
import GeneralInformationView from "../../components/partcreation/generalinformationview.vue";
import HoleCutout from "../../components/partcreation/holecutout.vue";
import { createCircle, } from "../utilities/geometry";
import { isValid, laserMaterialMap, } from "../utilities/material";
import { createSvg, defaultGeneralInformation, } from "../utilities/partcreation";
import { isNumber, } from "../utilities/wsi4_typeguards";
let CircleCutout = class CircleCutout extends Vue {
    constructor() {
        super(...arguments);
        this.generalInformation = defaultGeneralInformation;
        this.radius = 200.;
        this.holes = [];
        this.holesValid = true;
    }
    close() { }
    validInput(valid) { return valid; }
    transferData() {
        return {
            gasId: this.generalInformation.material.cuttingGasId,
            material: this.generalInformation.material.material,
            name: this.generalInformation.articleName,
            segments: [
                ...this.path.outerPolygon,
                ...this.path.innerPolygons.reduce((arr, i) => [
                    ...arr,
                    ...i,
                ], []),
            ],
            thickness: this.generalInformation.thickness,
        };
    }
    updateSvg() {
        const s = this.$el.querySelector(".part-creation-svg");
        if (s === undefined || s === null) {
            throw Error("Selector '.part-creation-svg' does not match");
        }
        if (s.contains(this.currentSvg)) {
            s.removeChild(this.currentSvg);
        }
        this.currentSvg = createSvg(this.path, {
            addMeasurements: true,
            profileParts: [],
        });
        s.appendChild(this.currentSvg);
    }
    updateInputFields() {
        if (this.holes.length === 0) {
            this.updateData();
        }
    }
    updateData() {
        if (this.validCircle) {
            this.updateSvg();
            this.transferData();
        }
        this.validInput(this.valid);
    }
    updateGeneralInformation(g) {
        this.generalInformation = g;
        this.updateData();
    }
    isValidNumber(n) { return isNumber(n) && n > 0; }
    isInRange(n, max) { return n < max; }
    updateHoleCutout(holes) {
        this.holes = holes;
        this.updateData();
    }
    updateHolesValid(holeValid) {
        this.holesValid = holeValid;
        this.updateData();
    }
    get size() { return 2. * this.radius; }
    get sizeInMaxRange() { return this.isInRange(this.size, Math.max(this.maximalLength, this.maximalWidth)); }
    get sizeValid() { return this.isValidNumber(this.radius) && this.sizeInMaxRange && this.sheetMinAreaValid; }
    get laserMaterialMap() { return laserMaterialMap(this.shopConfig, (m) => !isValid(this.shopConfig, [this.generalInformation.thickness], m.material.identifier, m.cuttingGasId)); }
    get sheet() {
        const allowedSheets = this.shopConfig.sheets.filter(s => s.thickness === this.generalInformation.thickness && s.sheetMaterialId === this.generalInformation.material.material.identifier);
        if (allowedSheets.length === 0) {
            return undefined;
        }
        return allowedSheets.reduce((res, s) => (s.dimX * s.dimY > res.dimX * res.dimY) ? s : res, allowedSheets[0]);
    }
    get sheetSizeBorder() { return 40.; }
    get maximalLength() { return this.sheet === undefined ? 0. : this.sheet.dimX - this.sheetSizeBorder; }
    get maximalWidth() { return this.sheet === undefined ? 0. : this.sheet.dimY - this.sheetSizeBorder; }
    get path() {
        return {
            outerPolygon: createCircle(this.radius),
            innerPolygons: this.holes,
        };
    }
    get area() {
        if (this.generalInformation.thickness > this.size) {
            return this.generalInformation.thickness * this.size;
        }
        return this.size * this.size;
    }
    get minArea() {
        if (!this.generalInformation.valid) {
            return -1;
        }
        const lm = this.shopConfig.laserSheetCuttingMaterial.find(m => m.sheetMaterialId === this.generalInformation.material.material.identifier);
        if (lm === undefined) {
            throw Error("Invalid laserCuttingMaterial");
        }
        const minArea = this.shopConfig.laserSheetCuttingMinAreas.find(l => this.generalInformation.thickness === l.thickness
            && l.sheetCuttingMaterialId === lm.sheetCuttingMaterialId
            && l.laserSheetCuttingGasId === this.generalInformation.material.cuttingGasId);
        if (minArea === undefined) {
            return -1;
        }
        return minArea.area;
    }
    get sheetMinAreaValid() {
        if (this.area === -1) {
            return true;
        }
        return this.area >= this.minArea;
    }
    get validCircle() {
        return this.generalInformation.valid && this.sizeValid && this.sheetMinAreaValid;
    }
    get valid() {
        return this.validCircle && this.holesValid;
    }
    get toolTip() {
        if (this.valid) {
            return "";
        }
        const m2 = " [mm²]";
        if (!this.isValidNumber(this.size)) {
            return this.i18n.t("sizeInvalid");
        }
        if (!this.sizeInMaxRange) {
            return this.i18n.t("maxSizeInvalid") + this.maximalLength.toString() + " x " + this.maximalWidth.toString() + m2;
        }
        if (!this.sheetMinAreaValid) {
            return this.i18n.t("sheetMinAreaInvalid") + this.minArea.toString() + m2;
        }
        return this.i18n.t("sizeInvalid");
    }
    get outerPolygonData() {
        return {
            radius: this.radius,
            thickness: this.generalInformation.thickness,
        };
    }
    mounted() { this.updateData(); }
};
__decorate([
    Prop({ required: true })
], CircleCutout.prototype, "shopConfig", void 0);
__decorate([
    Inject()
], CircleCutout.prototype, "i18n", void 0);
__decorate([
    Emit()
], CircleCutout.prototype, "close", null);
__decorate([
    Emit()
], CircleCutout.prototype, "validInput", null);
__decorate([
    Emit()
], CircleCutout.prototype, "transferData", null);
CircleCutout = __decorate([
    Component({
        components: {
            GeneralInformationView,
            HoleCutout,
        },
        name: "CircleCutout",
    })
], CircleCutout);
export default CircleCutout;
